import { defineMessages } from 'react-intl';

export const gridColumnLabelMessages = defineMessages({
  vendorNoLabel: {
    defaultMessage: 'Vendor No.',
    description: 'vendor id grid column text'
  },
  vendorNameLabel: {
    defaultMessage: 'Vendor Name',
    description: 'vendor name grid column text'
  },
  invoiceIdLabel: {
    defaultMessage: 'Invoice No.',
    description: 'Invoice No. grid column text'
  },
  netAmountLabel: {
    defaultMessage: 'Net Payment($)',
    description: 'NetPayment grid column text'
  },
  invoiceDescLabel: {
    defaultMessage: 'Invoice Description',
    description: 'invoice Description grid column text'
  },
  paymentMethodLabel: {
    defaultMessage: 'Payment Method',
    description: 'Payment Method grid column text'
  },
  invoiceExportDialogTitle: {
    defaultMessage: 'Export/Archive - Request Payment Authorization',
    description: 'Title for export/archive dialog'
  },
  invoiceExportAuthorizeDialogTitle: {
    defaultMessage: 'Export/Archive - Authorize Payment',
    description: 'Title for export/archive dialog for Authorize screen'
  }
});

export const messages = defineMessages({
  authorizePayment: {
    defaultMessage: 'Authorize Payment',
    description: 'Authorize Payment heading text'
  },
  authorizeText: {
    defaultMessage: 'Authorize',
    description: 'Authorize button to authorize the invoices'
  },
  printExport: {
    defaultMessage: 'Print/Export',
    description: 'Print/Export button to get the print and exports'
  },
  invoiceMoved: {
    defaultMessage: 'Invoice has been moved to Needs Authorization tab',
    description: 'Success message for Request Authorization'
  },
  invoicesMoved: {
    defaultMessage: 'Invoices have been moved to Needs Authorization tab',
    description: 'Success message (plural) for Request Authorization'
  },
  total: {
    defaultMessage: 'Total',
    description: 'total amount'
  },
  postingDescription: {
    defaultMessage: 'Posting Description',
    description: 'Mandatory field Posting Description'
  },
  postingDescriptionPlaceholder: {
    defaultMessage: 'Enter Description',
    description: 'Placeholder text for Posting Description field'
  },
  paymentDate: {
    defaultMessage: 'Payment Date',
    description: 'Mandatory field Payment Date'
  },
  invoices: {
    defaultMessage: 'Invoices',
    description: 'Invoices table title'
  },
  payByCreditCard: {
    defaultMessage: 'Pay by Credit Card',
    description: `Header label for 'Pay by Credit Card'`
  },
  payByCheck: {
    defaultMessage: 'Pay By Check',
    description: `Header label for 'Pay By Check'`
  },
  paymentDateErrorMessage: {
    defaultMessage: 'Invalid Payment Date',
    description: `Error message when payment date is Invalid`
  },
  postingDescriptionErrorMessage: {
    defaultMessage: 'Please Enter Posting Description',
    description: `Error message when postingDescription is empty`
  },
  authorizeCheckApproval: {
    defaultMessage:
      'Payment Authorized. The Check can now be printed from the Print Checks tab.',
    description: 'Authorize Check approval message'
  },
  authorizeChecksApproval: {
    defaultMessage:
      'Payment Authorized. The Checks can now be printed from the Print Checks tab.',
    description: 'Authorize Checks approval message'
  }
});

export const labels = defineMessages({
  authorizePaymentHeaderTitle: {
    defaultMessage: 'Authorize Payment Report',
    description: 'Authorize payment table header title in export to pdf page'
  },
  requestPaymentAuthorizationHeaderTitle: {
    defaultMessage: 'Request Payment Authorization Report',
    description:
      'Request payment authorization header title in export to pdf page'
  },
  printOrderLabel: {
    defaultMessage: 'Print Order',
    description: 'print order label'
  },
  vendorLabel: {
    defaultMessage: 'Vendor Name',
    description: 'vendor name'
  },
  vendorNumber: {
    defaultMessage: 'Vendor No.',
    description: 'vendor number'
  },
  printingChecksLabel: {
    defaultMessage: 'Printing checks...',
    description: 'Printing checks loader dialog label'
  },
  archiveChecksLabel: {
    defaultMessage: 'Archiving checks...',
    description: 'Archiving loader dialog label'
  },
  editLabel: {
    defaultMessage: 'Edit',
    description: 'Printing checks loader dialog label'
  },
  resetLabel: {
    defaultMessage: 'Reset',
    description: 'Printing checks loader dialog label'
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    description: 'Dismiss Button for Error Toast'
  }
});

export const errors = defineMessages({
  postApproval: {
    defaultMessage: 'Unable to request payment authorization',
    description: 'Error message for Request Authorization API call'
  },
  authorizePayment: {
    defaultMessage: 'Unable to authorize payments',
    description: 'Error message for Authorize API call'
  },
  deleteApproval: {
    defaultMessage: 'Unable to delete approvals',
    description: 'Error message for deleting credit card approvals'
  },
  cancelPayment: {
    defaultMessage: 'Unable to cancel payment',
    description: 'Error message for unlock invoices API failure'
  },
  virtualCardFailedCutoff: {
    defaultMessage:
      'Permission to post in current month is denied. Please adjust the payment date and try again.',
    description: 'Error message for VCC payment cutoff date'
  },
  initializationData: {
    defaultMessage: 'Unable to fetch initialization data',
    description: 'Error message for init data'
  },
  cashAccountData: {
    defaultMessage: 'Unable to fetch Cash Accounts',
    description: 'Error message for Cash Account data'
  },
  glPostingValidationFailure: {
    defaultMessage:
      'General ledger validation failed due to system error, please retry in a few minutes. If issue persists, contact CDK Support',
    description: 'Error message for GL posting validation'
  }
});
